import DefaultLink, { LinkProps as DefaultLinkProps } from 'next/link';
import React from 'react';
import { useClient } from 'ui-hooks/useClient';
import { DirittoAppBridge } from 'libs/DirittoAppBridge';

export interface LinkProps extends DefaultLinkProps {
  className?: string;
  children?: React.ReactNode;
  rel?: string;
  href: string;
  title?: string;
}

export const CertificateLink = ({ className, children, href, rel, ...rest }: LinkProps) => {
  const client = useClient();
  if (client.isApp) {
    return (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      <a href="" onClick={() => DirittoAppBridge.openSignView(href)}>
        {children}
      </a>
    );
  }

  return (
    <DefaultLink {...rest} href={href} passHref className={className} rel={rel}>
      {children}
    </DefaultLink>
  );
};
